<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户id"><el-input size="small" v-model="formInline.user_id" placeholder="请输入用户id"></el-input></el-form-item>
        <el-form-item label="用户姓名"><el-input size="small" v-model="formInline.truename" placeholder="请输入用户姓名"></el-input></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
  
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
           <el-table-column prop="nickName" label="昵称/ID" width="120">
            <template slot-scope="scope">
              <p>提现人：{{ scope.row.user.nickName }}</p>
              <p>ID:{{ scope.row.user.user_id }}</p>

            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">

              <p>{{ scope.row.user.mobile }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="avatarUrl" label="微信头像">
            <template slot-scope="scope">
              <div v-if="scope.row.user.avatarUrl">
                <img :src="scope.row.user.avatarUrl" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="moeny" label="提现金额"  align="center"></el-table-column>
          <el-table-column prop="fee" label="提现手续费"  align="center"></el-table-column>
          <el-table-column prop="apply_status" label="提现状态"  align="center"></el-table-column>
          <el-table-column prop="settle_account_id" label="汇付结算账号"  align="center"></el-table-column>
          <el-table-column prop="hf_member_id" label="汇付账号"  align="center"></el-table-column>
          <el-table-column prop="truename" label="姓名"  align="center"></el-table-column>
          <el-table-column prop="account" label="卡号"  align="center"></el-table-column>
          <el-table-column prop="bank.bank_name" label="银行名称"  align="center"></el-table-column>
          <el-table-column prop="bank_acct_type" label="类别"  align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.bank_acct_type==1">对公</el-tag>
              <el-tag type="success"  v-if="scope.row.bank_acct_type==2">对私</el-tag>
                
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"  align="center" ></el-table-column>
          
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
  import FinanceApi from '@/api/finance.js';
  import Add from './dialog/Add.vue';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
       Add,
      Edit,
  },
    data() {
      return {
        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        show_track:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          order_no: '',
          express_no: '',
        },
        dataModel:[],
      };
    },
    created() {
   
      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.limit = {
          page: self.curPage,
          list_rows:self.pageSize
        }
        FinanceApi.getCashList(Params).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        let Params = self.formInline;
        self.getTableList();
      },
      

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/finance/bank/cashlist.vue